export default {

    addAnalytics: () => {
        buttonClicks()
    }

}

function buttonClicks() {

    // signup buttons
    let signupButtons = document.querySelectorAll('.signup-button')
    signupButtons.forEach((element) => {
        element.addEventListener("click", (event) => {
            signUpLayer(element.getAttribute('data-location'))
        })
    }, this);

    // donate buttons
    let donateButtons = document.querySelectorAll('.donate-button')
    donateButtons.forEach((element) => {
        element.addEventListener("click", (event) => {
            donateLayer(element.getAttribute('data-location'))
        })
    }, this);

    // view community buttons
    let communityButtons = document.querySelectorAll('#community-page, #landing-page')
    communityButtons.forEach((element) => {
        element.addEventListener("click", (event) => {
            communityLayer(element.getAttribute('data-location'))
        })
    }, this);

    // Change region buttons
    let regionButtons = document.querySelectorAll('.region-btn')
    regionButtons.forEach((element) => {
        element.addEventListener('click', () => {
            if (window.dataLayer) {
                window.dataLayer.push({
                    'event': 'ccqEvent',
                    'eventCategory': 'Public Engagement',
                    'eventAction': 'Toggle Region',
                    'eventLabel': `Now viewing: ${element.innerHTML}`,
                    'eventValue': null,
                    'transport':'beacon'
                })
            }
        })
    }, this)

    document.querySelector('#promotion-tc a').addEventListener('click', () => {
        if (window.dataLayer) {
                window.dataLayer.push({
                    'event': 'ccqEvent',
                    'eventCategory': 'Public Engagement',
                    'eventAction': 'Viewed Promotion',
                    'eventLabel': 'Viewed T&C',
                    'eventValue': null,
                    'transport':'beacon'
                })
            }
    })
    
    // Landing Page Top Menu Search button
    document.querySelector('#artez-search').addEventListener('click', () => {
        if (window.dataLayer) {
            window.dataLayer.push({
                'event': 'ccqEvent',
                'eventCategory': 'Public Engagement',
                'eventAction': 'Search',
                'eventLabel': 'Landing Page',
                'eventValue': null,
                'transport':'beacon'
            })
        }
    })

    // Landing Page Top Menu Login Button
    document.querySelector('.loginsubmit-btn').addEventListener('click', () => {
        if (window.dataLayer) {
            window.dataLayer.push({
                'event': 'ccqEvent',
                'eventCategory': 'Public Engagement',
                'eventAction': 'Login',
                'eventLabel': 'Landing Page',
                'eventValue': null,
                'transport':'beacon'
            })
        }
    })

}

function signUpLayer(location) {
    if (window.dataLayer) {
        window.dataLayer.push({
            'event': 'ccqEvent',
            'eventCategory': 'Public Engagement',
            'eventAction': 'Sign Up',
            'eventLabel': `${location}`,
            'eventValue': null,
            'transport':'beacon'
        })
    }
}

function donateLayer(location) {
    if (window.dataLayer) {
        window.dataLayer.push({
            'event': 'ccqEvent',
            'eventCategory': 'Public Engagement',
            'eventAction': 'Donate',
            'eventLabel': `${location}`,
            'eventValue': null,
            'transport':'beacon'
        })
    }
}

function communityLayer(location) {
    if (window.dataLayer) {
        window.dataLayer.push({
            'event': 'ccqEvent',
            'eventCategory': 'Public Engagement',
            'eventAction': 'View Community',
            'eventLabel': `${location}`,
            'eventValue': null,
            'transport':'beacon'
        })
    }
}


// WEBPACK FOOTER //
// ./src/js/analytics.js